import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  projects: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    width: '100%',
  },
  project: {
    gap: anatomy['space-4'],
    alignItems: 'end',
    display: 'flex',
  },
  divider: {
    borderBottom: `1px dashed ${colors.tertiaryBorder}`,
    marginBottom: anatomy['space-4'],
    flexGrow: 1,
  },
  totalDivider: {
    height: '1px',
    backgroundColor: colors.activeBackground,
  },
  amount: {
    whiteSpace: 'nowrap',
  },
  total: {
    fontFamily: fonts.din2014Demi,
  },
});
